import { render, staticRenderFns } from "./OrderOperationRecordList.vue?vue&type=template&id=4087509a&scoped=true&"
import script from "./OrderOperationRecordList.vue?vue&type=script&lang=js&"
export * from "./OrderOperationRecordList.vue?vue&type=script&lang=js&"
import style0 from "./OrderOperationRecordList.vue?vue&type=style&index=0&id=4087509a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087509a",
  null
  
)

export default component.exports